import { gql, useQuery } from '@apollo/client';

import Entity from '../../components/entity';

import type { GetCurrentSessionQuery, GetCurrentSessionQueryVariables } from './__generated__/useCurrentSession.gql';

const GET_CURRENT_SESSION = gql`
  query GetCurrentSession {
    getCurrentSession {
      id
      user {
        id
        firstName
        lastName
        preferredName
        name
        email
        phoneNumber
        phoneNumberVerifiedAt
        avatarUrl
        timezone
        inferredTimezone
        createdAt
        ...EntityAvatar
      }
      impersonatorUserId
    }
  }
  ${Entity.Avatar.Fragment}
`;

export type CurrentSession = GetCurrentSessionQuery['getCurrentSession'];

export const useCurrentSession = () => {
  const { data, loading, error, refetch } = useQuery<GetCurrentSessionQuery, GetCurrentSessionQueryVariables>(
    GET_CURRENT_SESSION,
    {
      fetchPolicy: 'cache-and-network',
    }
  );

  return { session: data?.getCurrentSession ?? null, loading, error, refetch };
};
